<template>
  <div id="kid" class="page">
  <h1>Geburtstagskind</h1>
    <div id="kidsinfo">
      <div class="columns">
        <div class="column">
          <p><input placeholder="Name" name="kidsname" v-model="kid.kidsname"></p>
          <p><input placeholder="aus Stadt" name="kidscity" v-model="kid.kidscity"></p>
          <p><input placeholder="Geburtstag" name="birthday" v-model="kid.birthday"></p>
          
          <div class="actions">
            <p><a @click.prevent="saveKid" class="button">
            Weiter
            </a></p>
          </div>          
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {db} from '../service/firebase';  
export default {
  name: 'Kid',
  components: {
    
  },
  data () {
      return {
        kid: {
          'id': null,
          'kidsname': null,
          'kidscity':null,
          'birthday':null,
          'created_at': -1 * new Date().getTime(),
          'user' :this.$store.state.user ? this.$store.state.user.id : 'anonymus'

          }
        }
  },
  methods: {
    saveKid() {
      
      //this.$store.user = "Matt"
      
      var ref =  db.ref('/kids').push( this.kid )
      this.kid.id = ref.key
      
      if(this.kid.id) {
        this.$store.state.kid = this.kid;
        console.log( this.$store );
        this.$router.push('/user')
      } else {
        console.error('not saved to db!');
      }
      
      
        //console.log( db.ref('kids/'+ref.key).fetch() );
        //.then()
    }  
  },
  mounted: function(){
	  
	  console.log( this.$store.state );
  }
}

</script>
<style>
  input { display: block; width: 100%; padding: 0.6333333em 0.7333333em 0.3333333em; line-height: 1; border: 1px solid #ccc; border-radius: 0.3em; }
</style>
